module.exports = __webpack_public_path__ + "static/media/0005.1a8cfaa8.jpg";